import { A, Button, Flex } from 'dash-ui';
import styled, { useTheme } from 'styled-components';

const StyledButton = styled(Button)`
  justify-content: flex-start;
  align-items: center;
  border-color: ${({ theme }) => theme.colors.n40};

  & p {
    color: ${({ theme }) => theme.colors.n200};
  }
`;

// TODO: define as a system wide constants
const contactAdminEmail = 'mail@dash.com';
const contactAdminSubject = 'Organization Invitation';

const InvitationExpiredForm = () => {
  const theme = useTheme();

  return (
    <Flex w={334} mt={2}>
      <StyledButton
        w="100%"
        variation="outline"
        icon="email"
        iconProps={{ size: 20 }}
        p={2.5}
      >
        <A
          color={theme.colors.n90}
          textDecoration="none"
          href={`mailto:${contactAdminEmail}?subject=${contactAdminSubject}`}
        >
          {contactAdminEmail}
        </A>
      </StyledButton>
    </Flex>
  );
};

export default InvitationExpiredForm;
